var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8825 13.1348H12.43C11.9499 13.1348 11.4896 12.9441 11.1501 12.6047C10.8107 12.2652 10.62 11.8048 10.62 11.3248C10.62 11.8048 10.4293 12.2652 10.0899 12.6047C9.75042 12.9441 9.29004 13.1348 8.81 13.1348C8.32996 13.1348 7.86958 12.9441 7.53014 12.6047C7.1907 12.2652 7 11.8048 7 11.3248C7 11.8048 6.80931 12.2652 6.46987 12.6047C6.13043 12.9441 5.67005 13.1348 5.19001 13.1348C4.70997 13.1348 4.24959 12.9441 3.91015 12.6047C3.57071 12.2652 3.38001 11.8048 3.38001 11.3248C3.38001 11.8048 3.18931 12.2652 2.84987 12.6047C2.51043 12.9441 2.05006 13.1348 1.57001 13.1348H1.11752",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84621 9.28223C9.36321 8.69501 8.75615 8.22206 8.06863 7.89735C7.38112 7.57264 6.63022 7.40424 5.86988 7.40424C5.10954 7.40424 4.35864 7.57264 3.67113 7.89735C2.98362 8.22206 2.37655 8.69501 1.89355 9.28223",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84621 9.28223C9.36321 8.69501 8.75615 8.22206 8.06863 7.89735C7.38112 7.57264 6.63022 7.40424 5.86988 7.40424C5.10954 7.40424 4.35864 7.57264 3.67113 7.89735C2.98362 8.22206 2.37655 8.69501 1.89355 9.28223",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56372 7.45352C6.61999 5.33407 7.26708 3.40217 8.6738 2.70819",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86987 0.92633C6.47779 0.806626 7.10846 0.924699 7.63191 1.25621C8.15535 1.58773 8.53167 2.10742 8.6833 2.70817",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1063 3.05518C11.6747 2.58911 11.0877 2.29666 10.4557 2.23277C9.82369 2.16888 9.19009 2.33793 8.67391 2.70819",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23222 3.71162C5.5997 3.17022 6.1444 2.77384 6.77258 2.5907C7.40075 2.40755 8.07313 2.44909 8.67399 2.70816C9.27669 2.85556 9.7985 3.23143 10.1292 3.7564C10.46 4.28137 10.5737 4.91432 10.4465 5.5216",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingInput);
export default __webpack_public_path__ + "static/media/rating-input.22ab3cda50212b4b4cb2480eeb4763a3.svg";
export { ForwardRef as ReactComponent };